import '../language/typescript/monaco.contribution';
import '../language/css/monaco.contribution';
import '../language/json/monaco.contribution';
import '../language/html/monaco.contribution';
import '../basic-languages/monaco.contribution';

export * from './edcore.main';


//////////////////
// WEBPACK FOOTER
// ./node_modules/monaco-editor/esm/vs/editor/editor.main.js
// module id = 768
// module chunks = 53